import React from 'react';
import { Menu } from 'antd';
import { NavLink } from 'react-router-dom';
// import { ReactSVG } from 'react-svg';
import FeatherIcon from 'feather-icons-react';
import propTypes from 'prop-types';
// import versions from '../demoData/changelog.json';

// const { SubMenu } = Menu;

const MenuItems = ({ darkMode, toggleCollapsed, topMenu }) => {
  // temp: remove next line if you don't know what it is

  const path = window.location.pathname;
  const mainPathSplit = path.split('/')[1];

  // const { onRtlChange, onLtrChange, modeChangeDark, modeChangeLight, modeChangeTopNav, modeChangeSideNav } = events;
  const [openKeys, setOpenKeys] = React.useState(
    !topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : [],
  );

  const onOpenChange = (keys) => {
    setOpenKeys(keys[keys.length - 1] !== 'recharts' ? [keys.length && keys[keys.length - 1]] : keys);
  };

  const onClick = (item) => {
    if (item.keyPath.length === 1) setOpenKeys([]);
  };

  return (
    <Menu
      onOpenChange={onOpenChange}
      onClick={onClick}
      mode={!topMenu || window.innerWidth <= 991 ? 'inline' : 'horizontal'}
      theme={darkMode && 'dark'}
      // // eslint-disable-next-line no-nested-ternary
      defaultSelectedKeys={
        !topMenu
          ? [
              `${
                mainPathSplit.length === 1 ? 'home' : mainPathSplit.length === 2 ? mainPathSplit[1] : mainPathSplit[2]
              }`,
            ]
          : []
      }
      defaultOpenKeys={!topMenu ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : 'dashboard'}`] : []}
      overflowedIndicator={<FeatherIcon icon="more-vertical" />}
      openKeys={openKeys}
    >
      <Menu.Item key="home" icon={!topMenu && <FeatherIcon icon="home" />}>
        <NavLink onClick={toggleCollapsed} to="/admin">
          Dashboard
        </NavLink>
      </Menu.Item>
      <Menu.Item key="products" icon={!topMenu && <FeatherIcon icon="box" />}>
        <NavLink onClick={toggleCollapsed} to="/admin/products/list">
          Products
        </NavLink>
      </Menu.Item>
      <Menu.Item key="addons" icon={!topMenu && <FeatherIcon icon="box" />}>
        <NavLink onClick={toggleCollapsed} to="/admin/addons/list">
          Addons
        </NavLink>
      </Menu.Item>
      <Menu.Item key="users" icon={!topMenu && <FeatherIcon icon="users" />}>
        <NavLink onClick={toggleCollapsed} to="/admin/customers">
          Customers
        </NavLink>
      </Menu.Item>
      <Menu.Item key="orders" icon={!topMenu && <FeatherIcon icon="list" />}>
        <NavLink onClick={toggleCollapsed} to="/admin/ecommerce/orders/list">
          Orders
        </NavLink>
      </Menu.Item>
      <Menu.Item key="promos" icon={!topMenu && <FeatherIcon icon="list" />}>
        <NavLink onClick={toggleCollapsed} to="/admin/promos/list">
          Promos
        </NavLink>
      </Menu.Item>
      <Menu.Item key="settings" icon={!topMenu && <FeatherIcon icon="settings" />}>
        <NavLink onClick={toggleCollapsed} to="/admin/settings/list">
          Settings
        </NavLink>
      </Menu.Item>
    </Menu>
  );
};

MenuItems.propTypes = {
  darkMode: propTypes.bool,
  topMenu: propTypes.bool,
  toggleCollapsed: propTypes.func,
  events: propTypes.object,
};

export default MenuItems;
